import gql from 'graphql-tag';

export default gql`
  query getListTeamByFilter($input: GetListTeamByFilterInput!) {
    getListTeamByFilter(input: $input) {
      totalResults
      totalPage
      data {
        id
        name
        code
      }
    }
  }
`;
